





































































import {Component, Prop, Vue} from "vue-property-decorator";
import {formatDate, getMonthName} from "@/lib/date";
import XButton from "../SimpleButton.vue";
import {AppealCustomFields} from "@/models/appeals";
import XMoneyCustomField
  from "@/components/for-custom-form/MoneyCustomField.vue";


@Component({
  components: {XMoneyCustomField, XButton},
})
class DateMonthCustomField extends Vue {
  [x: string]: any;

  @Prop({ default: "month"}) readonly type!: string;
  @Prop({ required: true }) readonly item!: AppealCustomFields;
  @Prop({ default: "" }) readonly fieldName!: string;
  @Prop({ default: false }) readonly required!: boolean;
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: () => [] }) errorMessages: any;

  isDropdownDisplayed = false;

  date = "";
  value = "";

  emptyValue() {
    return this.type == "month" ? "__.____" : "__.__.____";
  }

  public created() {
    this.value = this.emptyValue();
  }

  customRuleMonth() {
    if (this.required) {
      return [
        v => (v || this.emptyValue()) !== this.emptyValue() || "Заполните данное поле",
      ];
    }
    return [];
  }

  public applyDateChanges() {
    this.value = this.type == 'month' ?
      formatDate(this.date, "monthAndYear") :
      formatDate(this.date, "full");
    this.item['значение'] = this.value;
    this.item['ошибка'] = "";
    this.isDropdownDisplayed = false;
  }

  public resetDateChanges() {
    this.date = "";
    this.value = this.emptyValue();
    this.item['значение'] = "";
    this.item['ошибка'] = "";
    this.isDropdownDisplayed = false;
  }

  public formatMonth(date: string): string {
    return this.type == 'month' ?
      getMonthName(date, true).toUpperCase() :
      null;
  }
}

export default DateMonthCustomField;
